const config = {
  development: {
    API_URLS: {
      logreg: 'https://fn-san-hrma-apps-logreg.azurewebsites.net/api',
      managebusiness: 'https://fn-san-hrma-apps-managebusiness.azurewebsites.net/api',
      manageemployees: 'https://fn-san-hrma-apps-manageemployees.azurewebsites.net/api',
      manageclients: 'https://fn-san-hrma-apps-manageclients.azurewebsites.net/api',
      managepictures: 'https://fn-san-hrma-apps-managepictures.azurewebsites.net/api',
      manageservices: 'https://fn-san-hrma-apps-manageservices.azurewebsites.net/api',
      managebookings: 'https://fn-san-hrma-apps-managebookings.azurewebsites.net/api',
      manageleave: 'https://fn-san-hrma-apps-manageleave.azurewebsites.net/api',
      tracktime: 'https://fn-san-hrma-apps-tracktime.azurewebsites.net/api',
      trackgoals: 'https://fn-san-hrma-apps-trackgoals.azurewebsites.net/api',
      managechecklist: 'https://fn-san-hrma-apps-managechecklist.azurewebsites.net/api',
      managestock: 'https://fn-san-hrma-apps-managestock.azurewebsites.net/api',
      managepayments: 'https://fn-san-hrma-apps-managepayments.azurewebsites.net/api',
      whatsapp: 'https://fn-san-hrma-apps-whatsapp.azurewebsites.net/api',
      admin: 'https://fn-san-hrma-server-apps-admin.azurewebsites.net/api',
      support: 'https://fn-san-hrma-server-apps-support.azurewebsites.net/api',
      edubilling: 'https://fn-san-edu-server-apps-billing-gzh8gtcyfed5bnea.southafricanorth-01.azurewebsites.net/api'
    },
    // Paystack public keys — the billing page picks the right one based on the HRMA payment mode
    PAYSTACK_PUBLIC_KEY_LIVE: 'pk_test_15f9793a49d400bf133834c796ef518e974c9809',
    PAYSTACK_PUBLIC_KEY_TEST: 'pk_test_15f9793a49d400bf133834c796ef518e974c9809',
    // Legacy — kept for any code that still reads it directly
    PAYSTACK_PUBLIC_KEY: 'pk_test_15f9793a49d400bf133834c796ef518e974c9809',
    USE_FUNCTION_KEYS: false,
    EDU_LOGIN_URL: 'https://edu.1nespa.com/login'
  },
  production: {
    API_URLS: {
      logreg: 'https://fn-san-hrma-apps-logreg.azurewebsites.net/api',
      managebusiness: 'https://fn-san-hrma-apps-managebusiness.azurewebsites.net/api',
      manageemployees: 'https://fn-san-hrma-apps-manageemployees.azurewebsites.net/api',
      manageclients: 'https://fn-san-hrma-apps-manageclients.azurewebsites.net/api',
      managepictures: 'https://fn-san-hrma-apps-managepictures.azurewebsites.net/api',
      manageservices: 'https://fn-san-hrma-apps-manageservices.azurewebsites.net/api',
      managebookings: 'https://fn-san-hrma-apps-managebookings.azurewebsites.net/api',
      manageleave: 'https://fn-san-hrma-apps-manageleave.azurewebsites.net/api',
      tracktime: 'https://fn-san-hrma-apps-tracktime.azurewebsites.net/api',
      trackgoals: 'https://fn-san-hrma-apps-trackgoals.azurewebsites.net/api',
      managechecklist: 'https://fn-san-hrma-apps-managechecklist.azurewebsites.net/api',
      managestock: 'https://fn-san-hrma-apps-managestock.azurewebsites.net/api',
      managepayments: 'https://fn-san-hrma-apps-managepayments.azurewebsites.net/api',
      whatsapp: 'https://fn-san-hrma-apps-whatsapp.azurewebsites.net/api',
      admin: 'https://fn-san-hrma-server-apps-admin.azurewebsites.net/api',
      support: 'https://fn-san-hrma-server-apps-support.azurewebsites.net/api',
      edubilling: 'https://fn-san-edu-server-apps-billing-gzh8gtcyfed5bnea.southafricanorth-01.azurewebsites.net/api'
    },
    // Paystack public keys — the billing page picks the right one based on the HRMA payment mode
    PAYSTACK_PUBLIC_KEY_LIVE: 'pk_live_0b8b6414b3c82c0f1fd50b8d38f4ff0c00b088a4',
    PAYSTACK_PUBLIC_KEY_TEST: 'pk_test_15f9793a49d400bf133834c796ef518e974c9809',
    // Legacy — kept for any code that still reads it directly
    PAYSTACK_PUBLIC_KEY: 'pk_live_0b8b6414b3c82c0f1fd50b8d38f4ff0c00b088a4',
    USE_FUNCTION_KEYS: false,
    EDU_LOGIN_URL: 'https://edu.1nespa.com/login'
  }
};

// Simple environment detection that works in browser
const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const currentConfig = isDevelopment ? config.development : config.production;

export default currentConfig;
